<template>
  <div id="login">
    <div id="container">
      <div id="content">
        <div id="page-title">
          <img :src="getImage('component/common/header/daros_logo_black.svg')" width="300px" height="auto"/>
          <p class="sentence1">Domans Automatic Realization & Operation System</p>
        </div>
        <div class="error_message">{{ errorMessage.text }}</div>
        <div class="input_list">
          <ul>
            <li>
              <span>
                <label class="list_key">ログインID（メールアドレス）</label>
              </span>
              <input type="text" class="list_box" v-model="form.loginId" placeholder="メールアドレスを入力してください"/>
              <label v-show="fieldErrorMessages.loginId" class="error_message">
                {{fieldErrorMessages.loginId}}
              </label>
            </li>
            <li>
              <span>
                <label class="list_key">パスワード</label>
              </span>
              <input type="password" class="list_box" v-model="form.password" placeholder="パスワードを入力してください"/>
              <label v-show="fieldErrorMessages.password" class="error_message">
                {{fieldErrorMessages.password}}
              </label>
            </li>
          </ul>
          <button type="submit" class="main_btn login_btn" @click="login">ログイン</button>
          <!-- TODO パスワードリセット機能が未実装のため非表示 -->
          <!-- <p>パスワードをお忘れの方</p> -->
        </div>
      </div>
    </div>
    <dd-footer />
  </div>

</template>

<script>
import axios from 'axios'
import {API_URL, KEY_CODE, STORAGE_KEY} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import Footer from '../components/common/Footer'

export default {
  name: 'Login',
  components: {
    'dd-footer': Footer
  },
  data () {
    return {
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  methods: {
    login: function (event) {
      event.preventDefault()
      axios.post(API_URL.LOGIN,
        {
          loginId: this.form.loginId,
          password: this.form.password
        }
      ).then(response => {
        if (response.data.errorMessage) {
          this.clearMessages()
          this.errorMessage.text = response.data.errorMessage
        } else {
          // ログイン成功時ローカルストレージにユーザー情報を格納※セキュリティ上問題ないもののみ
          let data = response.data.data
          let userInfo = {
            corpId: data.corpId,
            corpName: data.corpName,
            userName: data.userName,
            userType: data.userType,
            userStatus: data.userStatus,
            userOrderType: data.userOrderType,
            licenseType: data.licenseType,
            menuServiceCode: data.menuServiceCode
          }
          App.setLocalStorage(STORAGE_KEY.USER_INFO, userInfo)
          // ログイン成功時の遷移先
          if (userInfo.userStatus === 1) {
            if (userInfo.licenseType !== 4) {
              const transitionUrlName = App.getLocalStorage(STORAGE_KEY.TRANSITION_URL_NAME)
              if (transitionUrlName != null && Object.keys(transitionUrlName).length > 0) {
                // ストレージに遷移先のnameがあったらその画面に遷移
                this.$router.push({
                  name: transitionUrlName
                })
                App.removeLocalStorage(STORAGE_KEY.TRANSITION_URL_NAME)
              } else {
                // 通常ユーザーはトップ画面
                this.$router.push('/')
              }
            } else {
              // お試しユーザーはプランニング画面
              this.$router.push('/planning')
            }
          } else if (userInfo.userStatus === 2) {
            // 初回パスワード設定画面
            this.$router.push('/password')
          }
        }
      }).catch(error => {
        this.clearMessages()
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        loginId: '',
        password: ''
      }
    },
    /** enterキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        event.preventDefault()
        this.login(event)
      }
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  mounted: function () {
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy: function () {
    document.removeEventListener('keydown', this.onKeydown)
  }
}

</script>
<style lang="scss" scoped>
#login {
  height: calc(100% - 51px);
  min-height: 260px;
  min-width: 500px;
}
#container {
  height: 100%;
  display: flex;
  justify-content: center;
}
#content {
  padding-top: 80px;
  text-align: center;
  display: block;
  form {
    padding: 20px 50px;
  }
}
#page-title {
  margin-bottom: 25px;
  p {
    font-size: 12.75px;
    margin-top: 10px;
  }
}
.input_list{
  ul {
    text-align: left;
    margin: 0 38px;
    li {
      margin: 10px 0;
      span {
        display: block;
        margin-bottom: 7px;
        .list_key {
          font-weight: bold;
        }
      }
      input {
        width: 273px;
        height: 35px;
      }
    }
  }
}
.error_message {
  display: block;
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/Login.vue